import React from 'react'
import { Card, Button, Box, Typography, Grid } from '@mui/material'
import RFG from "../../libs/inputs/RFG"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from 'react-hook-form'
import { LOGIN } from "../../services/actions"
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import authImg from '../../layouts/yellow_white_logo.png'
import bgImg from './bg.jpg'
const centerBoxFlex = {
  overflow: 'hidden',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

export default function Login() {
  const navigate = useNavigate()
  let dispatch = useDispatch()
  let user = useSelector((state) => state?.loginState)

  const { handleSubmit, control } = useForm({
    // defaultValues: { "username": "admin@gmail.com", password: "Admin@123" },

    mode: "all"
  })

  const cardRef = React.useRef(null);
  const [sessionExpiredMessage, setSessionExpiredMessage] = React.useState(null);

  React.useEffect(() => {
    const reason = sessionStorage.getItem("session_terminated_reason");
    if (reason) {
      setSessionExpiredMessage(reason);
      sessionStorage.removeItem("session_terminated_reason");
    }
  }, []);
  return (
    <>
      <Box sx={{ ...centerBoxFlex }}>
        <Box sx={{ ...centerBoxFlex, width: 1, position: 'absolute' }}>

          <Box sx={{
            minWidth: { md: 470, xs: 210 },
            background: '#000000b8', px: 6, py: 5,
            borderRadius: 4,
            backdropFilter: 'blur(3px)'
          }}>
            <Box sx={{ textAlign: 'center' }}>
              <Box component={'img'} src={authImg} />
            </Box>
            <Box sx={{ mt: 3 }}>
              <Typography fontSize={16} fontWeight={400} color="#fff">Login</Typography>

            </Box>
            <Box>
              <Typography fontSize={13} sx={{ my: 2 }} color="#ffffffff">Welcome to widelapse monitoring system</Typography>
            </Box>
            {sessionExpiredMessage && (
              <Box
                sx={{
                  mb: 2,
                  p: 1.5,
                  borderRadius: 2,
                  backgroundColor: "rgba(239, 68, 68, 0.2)",
                  border: "1px solid #ef4444",
                  color: "#fca5a5",
                  fontSize: "13px",
                  lineHeight: 1.4,
                }}
              >
                <Typography fontSize={13} sx={{ color: "#fecaca" }}>
                  {sessionExpiredMessage}
                </Typography>
              </Box>
            )}
            <form autoComplete="false" onSubmit={handleSubmit((data) => {
              setSessionExpiredMessage(null);
              const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
              console.log("FORM", data, "Timezone:", clientTimezone);
              dispatch({ type: `${LOGIN}_AUTH`, payload: { ...data, timezone: clientTimezone } });
            })}>
              <RFG labelStyle={{ color: "#a4a4a4" }} name="username" label="Email as Username" control={control} className="mb-2">
                <input placeholder='Enter email' autoComplete="false" style={{ borderRadius: 8, color: "#717171" }} />
              </RFG>
              <RFG labelStyle={{ color: "#a4a4a4" }} name="password" label="Password" control={control} className="mb-2">
                <input placeholder='Enter password' style={{ borderRadius: 8, color: "#717171" }} type="password" />
              </RFG>
              <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171", cursor: 'pointer' }}
                onClick={() => { navigate('/forgot-password/') }}
              ></Typography>
              <Button sx={{
                width: 1, my: 2, background: '#ffd85f',
                color: '#000', borderRadius: 2, textTransform: 'capitalize'
              }} type="submit">Login</Button>
              <Button type="button"
                onClick={() => { navigate('/forgot-password/') }}
                sx={{
                  width: 1, my: 2, background: '#000000ff', color: '#ffd85f',
                  borderRadius: 2, textTransform: 'capitalize', border: '1px solid white'
                }} >Forgot Password</Button>
            </form>

            {(user?.message || user?.error) ? (
              <Box
                className="error"
                sx={{
                  my: 1.5,
                  p: 1.5,
                  borderRadius: 2,
                  backgroundColor: "rgba(239, 68, 68, 0.15)",
                  border: "1px solid #ef4444",
                  color: "#fca5a5",
                  fontSize: "13px",
                  textAlign: "center"
                }}
              >
                {user?.message || user?.error}
              </Box>
            ) : null}

            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
              <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#c2c2c2ff" }}>Powered by widelapse</Typography>
              <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#c2c2c2ff" }}>Terms & conditions</Typography>
            </Box>
          </Box>
        </Box >
        <Box component={'img'}
          src={bgImg} sx={
            {
              width: { xs: 'auto', sm: '100%' },
              height: { xs: '100vh' }
            }
          }
        />
      </Box>
    </>
  )
}

